/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import Image1 from 'assets/images/onboarding_organize_ad_1.png';
import Image2 from 'assets/images/onboarding_organize_ad_2.png';
import Image3 from 'assets/images/onboarding_organize_ad_3.png';

const CaptureAds = ({ animationCount }) => {
  const [imgClicked, setImgClicked] = useState(0);
  const isMobile = window.innerWidth < 768;

  const onImageClick = () => {
    setImgClicked(imgClicked + 1);
  };

  const showLastItem = isMobile ? imgClicked === 2 : imgClicked === 1;

  useEffect(() => {
    if (animationCount) {
      setImgClicked(animationCount);
    }
  }, [animationCount]);

  return (
    <div
      className={`position-relative flex-fill d-md-block onboarding-organize-ad with-hover ${
        showLastItem ? 'clicked' : ''
      } ${animationCount ? `anim-${animationCount}` : ''}`}
      onMouseLeave={() => {
        setImgClicked(0);
      }}
    >
      <img src={Image1} alt='add-likie' className='img-add-likiee' />
      <img src={Image2} alt='images' className='img-images' onClick={onImageClick} />
      <img src={Image3} alt='product' className='img-product' />
    </div>
  );
};

export default CaptureAds;
